import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=921bdd8c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=921bdd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921bdd8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921bdd8c')) {
      api.createRecord('921bdd8c', component.options)
    } else {
      api.reload('921bdd8c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=921bdd8c&scoped=true&", function () {
      api.rerender('921bdd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MjoHutwhclwN/JS/teamMember.vue"
export default component.exports